







import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    value: {
      type: Object,
      default: () => { return {}}
    }
  },
  setup(props, { emit }) {

    const agregar = (archivo) => {
      // const obj = { ...archivo, nombre: archivo.name }
      console.log("emitiendo:", archivo)
        emit("input", archivo)
    }

    const eliminar = (nombre) => {
        const { value } = props
        // const index = value.findIndex((a: any) => a.nombre == nombre)
        // emit("input", [...value].splice(index, 1))
    }

    return {
      agregar,
      eliminar
    }
  },
});
